module.exports = __webpack_public_path__ + "img/banner.79ad718b.jpg";